<template>
    <div class="nick-logo center">
        <div class="logo inline-block">
            <img id="img" :src="imageSrc ? 
            imageSrc :
            '../../../static/img/default.png'" alt="">
        </div>
        <div class="center">
        <span @click="sheetVisible = true">{{ editAvatar }}</span>
        </div>
        <!-- 从相册中选择 -->
        <mt-actionsheet :actions="actions" v-model="sheetVisible" ></mt-actionsheet>
        <!-- 隐藏的上传组件 -->
        <input
            style="display: none"
            id="uploadAvatar"
            type="file"
            accept="image/*"
            @change="change($event)"
        />
        <!--@change="change($event)" @change="onFileChange"-->
    </div>
</template>

<script>

export default {
  props: ['editAvatar', 'imageSrc'],
  name: 'Avatar',
  data() {
    return {
        sheetVisible: false,
        actions: [
            {
                name: '更改头像',
                method: this.openAlbum
            }
        ],
    }
  },
  methods: {
  	change( event ) {
        let image = document.getElementById('img'); //预览对象
        this.clip(event , {
          resultObj : image,
          aspectRatio : 1
        })
    },
  	openAlbum() {
    	// 触发上传头像
    	document.getElementById("uploadAvatar").click();
  	},
  	onFileChange(file) {
      this.$store.dispatch('user/uploadUserAvatar', file)
  	}
  },
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.nick-logo {
    color: #7F7F7F;
    margin-bottom: 15px;
}
.logo {
    color: #7F7F7F;
    width: 64px;
    height: 64px;
    margin-top: 24px;
    background-color: #D8D8D8;
    border-radius: 50%;
    border: #fff solid 4px;
    overflow: hidden;
}
.logo img {
    width: 100%;
    height: 100%;
    border: 3px solid #fff;
    box-sizing: border-box;
    border-radius: 50%;
}
</style>



// WEBPACK FOOTER //
// src/components/userEditElement/Avatar.vue